import { API_CALL_SUCCESS } from '../constants/actionTypes';
import {
    SALES_GET,
    SALES_FIND,
    SALES_PUT,
} from '../constants/apiConstants';

const initialState = {};

const apiSalesReducer = (state, action) => {
    const {
        endpoint,
    } = action;

    switch (endpoint) {
    case SALES_GET:
    case SALES_PUT:
        return action.response;
    case SALES_FIND:
        return action.response.length >= 1 ? action.response[0] : {};
    default:
        return state;
    }
};

const salesReducer = (state = initialState, action) => {
    const {
        type,
    } = action;

    switch (type) {
    case API_CALL_SUCCESS:
        return apiSalesReducer(state, action);
    default:
        return state;
    }
};

export const selectSale = ({ sale }) => {
    return sale;
};

export default salesReducer;
